<template>
    <div class="search-ms__panel_button">
        <button class="search-ms__button">
            <slot></slot>
        </button>
    </div>
</template>
<script>
</script>
<style>
 /* -------- button -------- */
    .search-ms__panel_button{
        width: 192px;
        height: 42px;
    }
    .search-ms__button{
        box-sizing: border-box;
        border: solid 2px #175472;
        color: #0D3041;
        border-radius: 10px;
        background-color: var(--background);
        font-weight: 401;
        height: 100%;
        width: 100%;
        font-size: 14px;
        cursor: pointer;
        line-height: 130%;
        font-family: Rubik;
 /* font-variant: small-caps;  */

    }

    .search-ms__button:hover{
        background-color: #EDF6FF;
    }
    .search-ms__button:active{
        background-color:#174E72;
        color: #FFF;
    }
/* !------- button -------! */
</style>